import {
  NgModule
} from '@angular/core';
import {UserContext} from '../../../../services/user-context';
import {PageHeaderComponent} from './page-header.component';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {CommonModule} from '@angular/common';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {SearchContext} from '../../../../services/search/search-context';
import {FlexLayoutModule} from '@angular/flex-layout';
import {RouterModule} from '@angular/router';
import {LoadingIndicatorModule} from '../loading-indicator';


@NgModule({

  imports: [
    ButtonsModule,
    CommonModule,
    InputsModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    FlexLayoutModule,
    LoadingIndicatorModule
  ],
  declarations: [
    PageHeaderComponent
  ],
  exports: [
    PageHeaderComponent
  ],
  providers: [
    UserContext,
    SearchContext
  ],
  entryComponents: [],
})
export class PageHeaderModule {
}
